import {Test} from 'lib/test'
import * as React from 'react'
import {CircularProgressBar} from "app/Components/ProgressBar";
import {STAREForm} from "./STAREForm";

type PreviewProps = {
    test: Test
}

export class STARERawData extends React.Component<PreviewProps> {
    public render = () => <>
        {this.props.test && this.props.test.content ?
            <STAREForm data={this.props.test.content.data} preview={true} /> : <CircularProgressBar/>
        }
    </>
}